// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2uGt8";
var _4 = "content-_eccw";
var _5 = "header-2beoo";
var _6 = "location-1n7EO";
var _7 = "description-vVdHl";
var _8 = "description__inner-2wjxF";
var _9 = "options-TMLNE";
var _a = "images-3rA20";
var _b = "placeholder-tvyzx";
var _c = "placeholder_vip-eWc0Z";
var _d = "placeholder_meet-1cwXf";
var _e = "placeholder_lounge-2Bp-L";
var _f = "placeholder_fasttrack-aT1XG";
var _10 = "image-1aR4_";
var _11 = "image__thumb-2q4vD";
var _12 = "slider-lWGcI";
var _13 = "buttons-1OhZr";
var _14 = "button-283nF";
var _15 = "button_selected-2Ruy3";
var _16 = "price-1TB5d";
var _17 = "button_priceFrom-i_7Kh";
var _18 = "price__wrapper-8R9yE";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "content", _5 as "header", _6 as "location", _7 as "description", _8 as "description__inner", _9 as "options", _a as "images", _b as "placeholder", _c as "placeholder_vip", _d as "placeholder_meet", _e as "placeholder_lounge", _f as "placeholder_fasttrack", _10 as "image", _11 as "image__thumb", _12 as "slider", _13 as "buttons", _14 as "button", _15 as "button_selected", _16 as "price", _17 as "button_priceFrom", _18 as "price__wrapper" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "content": _4, "header": _5, "location": _6, "description": _7, "description__inner": _8, "options": _9, "images": _a, "placeholder": _b, "placeholder_vip": _c, "placeholder_meet": _d, "placeholder_lounge": _e, "placeholder_fasttrack": _f, "image": _10, "image__thumb": _11, "slider": _12, "buttons": _13, "button": _14, "button_selected": _15, "price": _16, "button_priceFrom": _17, "price__wrapper": _18 }
